import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import { Rocket, Target, Users } from 'lucide-react';
import { useSiteSettings } from '@/lib/hooks/useSiteSettings';
export default function AboutNZ() {
  const $ = _c(5);
  useSiteSettings();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[600px] h-[600px] bg-primary-50 rounded-full blur-3xl opacity-50" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tight">We're on a mission to <br /><span className="text-primary-600">Help You Sizzle</span></h1>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="relative pt-32 pb-20 overflow-hidden">{t0}<div className="container mx-auto px-6 relative z-10 text-center">{t1}<div className="flex justify-center gap-4"><div className="px-6 py-3 bg-gray-50 border border-gray-100 rounded-2xl"><span className="text-sm font-semibold text-gray-700">A Sizzle CPG Labs venute</span></div></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-24"><div className="container mx-auto px-6"><div className="max-w-4xl mx-auto"><div className="prose prose-xl prose-gray"><h2 className="text-4xl font-black text-gray-900 mb-8">The Story of Sizzle</h2><p className="text-lg text-gray-600 mb-6 leading-relaxed">Coming Soon</p></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="min-h-screen bg-white">{t2}{t3}<section className="py-24 px-6 bg-gray-50"><div className="container mx-auto"><div className="p-12 md:p-24 text-center relative overflow-hidden"><Link href="/" className="px-12 py-6 bg-primary-600 text-white font-black text-xl rounded-2xl shadow-xl shadow-primary-200 hover:bg-primary-700 hover:scale-105 transition-all inline-block relative z-10 cursor-pointer">Start Exploring</Link></div></div></section></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}